import { Distribute, Icon, Spacer, SvgEye, Text } from '@loomhq/lens';
import pluralize from 'pluralize';
import React from 'react';
import { useSelector } from 'react-redux';

import { selectUserCanEditVideo } from 'selectors/shareVideo';
import { selectVideoViews } from 'selectors/videoPlayer';

export default () => {
  const canSeeInsights = useSelector(selectUserCanEditVideo);

  if (canSeeInsights) {
    return null;
  }

  const views = useSelector(selectVideoViews);
  const totalViews = views?.total || 0;

  return (
    <Spacer top="small" right="medium">
      <Distribute gap="xsmall">
        <Icon icon={<SvgEye />} />
        <Text weigth="medium">
          {totalViews} {pluralize('view', Number(totalViews))}
        </Text>
      </Distribute>
    </Spacer>
  );
};
